module.exports = __webpack_public_path__ + "static/media/icon-phone.b9889624.svg";